import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

// Isolado do Hero de propósito: o setState roda a cada ~60-120ms pra sempre
// (efeito de digitar/apagar em loop), então mantê-lo aqui garante que só
// este span pequeno re-renderiza, não a seção inteira do Hero.
const TypingTagline = () => {
    const { t, i18n } = useTranslation();
    const fullText = t('hero.title');

    const [text, setText] = useState("");
    const [index, setIndex] = useState(0);
    const [isDeleting, setIsDeleting] = useState(false);

    useEffect(() => {
        setText("");
        setIndex(0);
        setIsDeleting(false);
    }, [i18n.language]);

    useEffect(() => {
        if (!fullText) return;

        const timer = setTimeout(() => {
            if (!isDeleting && index < fullText.length) {
                setText(fullText.substring(0, index + 1));
                setIndex(index + 1);
            } else if (!isDeleting && index === fullText.length) {
                setTimeout(() => setIsDeleting(true), 3000);
            } else if (isDeleting && text.length > 0) {
                setText(text.substring(0, text.length - 1));
            } else if (isDeleting && text.length === 0) {
                setIsDeleting(false);
                setIndex(0);
            }
        }, isDeleting ? 60 : (80 + Math.random() * 40));

        return () => clearTimeout(timer);
    }, [text, index, isDeleting, fullText]);

    return (
        <div className="text-2xl md:text-3xl mb-8 h-12">
            <span className="text-gray-300">{text}</span>
            <motion.span
                animate={{ opacity: [0, 1, 0] }}
                transition={{ repeat: Infinity, duration: 0.8 }}
                className="ml-1 inline-block text-blue-400"
            >
                |
            </motion.span>
        </div>
    );
};

export default TypingTagline;
